import "./App.css";
import React, { useState, useEffect } from "react";
import Macbook from "./img/macbook_mockup.png";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import TwitterIcon from "@mui/icons-material/Twitter";
// import { useNavigate } from "react-router-dom";
import { Typography, IconButton } from "@mui/material";
import { useHistory } from "react-router-dom";
import { ChevronRight, ExpandMore } from "@mui/icons-material";
import IphoneImage from "./img/iphone_mockup.png";
import verified from "../../../assets/img/verified.png";
import disbursement from "../../../assets/img/disbursement.png";
import mutual_agreement from "../../../assets/img/mutual_agreement.png";
import one from "../../../assets/img/one.png";
import five from "../../../assets/img/newong-01.png";
import six from "../../../assets/img/newong-02.png";
import two from "../../../assets/img/two.png";
import three from "../../../assets/img/three.png";
import four from "../../../assets/img/four.png";
import SgIcon from "./img/197496.png";
import CloseIcon from "@mui/icons-material/Close";
import bank_image from "../../../assets/img/bank_image.png";
import { Modal, Button, message } from "antd";
import tiktokIcon from "./img/tik-tok.png";
import telegramicon from "./img/telegram.png";
import linkedinicon from "./img/linkedin.png";
import whatsappicon from "./img/whatsapp.png";
import HomeHeader from "./Headesr.jsx";

const TermCondition = () => {
  // const navigate = useHistory();
  const history = useHistory();

  const [screenWidth, setScreenWidth] = useState(1920);
  const [pageLoad, setPageLoad] = useState(false);
  const [screenHeight, setScreenHeight] = useState(1080);
  useEffect(() => {
    setPageLoad(true);
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
      setScreenHeight(window.innerHeight);
    };

    // Call handleResize initially to set the initial screen width
    handleResize();

    // Add event listener for resize
    window.addEventListener("resize", handleResize);

    // Clean up the event listener on component unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const [privacyBar, setPrivacybar] = useState(true);
  useEffect(() => {
    if (screenWidth > 1200) {
      setPrivacybar(true);
    }
  }, []);

  useEffect(() => {
    if (screenWidth < 1200) {
      setPrivacybar(false);
    }
  }, [screenWidth]);
  return (
    <div style={{ width: "100%", overflowX: "hidden", position: "relative" }}>
      <div
        style={{
          background: "white",
          position: "fixed",
          width: "100%",
          height: "40px",
          display: privacyBar ? "flex" : "none",
          justifyContent: "space-between",
          alignItems: "center",
          zIndex: "49",
          background: "rgb(37, 97, 153)",
        }}
      >
        <div
          style={{
            marginLeft: "20px",
            color: "rgba(0,0,0,0.7)",
            fontSize: "14px",
            color: "white",
          }}
        >
          Information is collected in accordance with our Privacy Policy by
          continuing you agree to our terms.
        </div>
        <CloseIcon
          style={{ marginRight: "20px", cursor: "pointer", color: "white" }}
          onClick={() => setPrivacybar(false)}
        />
      </div>
      {/* Header bar */}
      <div
        style={{
          position: "fixed",
          background: "white",
          display: "flex",
          justifyContent: "center",
          height: "70px",
          boxShadow: "0px 0px 10px rgba(0,0,0,0.2)",
          alignItems: "center",
          width: "100%",
          top: privacyBar ? "40px" : "0px",
          zIndex: "50",
        }}
      >
        <HomeHeader />
      </div>
      <div
        style={{
          padding: "35px 0px",
          textAlign: "center",
          background: "#256199",
          marginLeft: pageLoad ? "0px" : "-300px",
          opacity: pageLoad ? "1" : "0",
          transition: "all 0.8s ease-in-out",
          marginTop: "100px",
        }}
      >
        <div
          style={{
            fontSize: screenWidth > 1200 ? "45px" : "30px",
            fontWeight: "700",
            color: "white",
          }}
        >
          Terms and Conditions
        </div>
        {/* <div
          style={{ display: "flex", justifyContent: "center", width: "100%" }}
        >
          <div
            style={{
              fontSize: "15px",
              fontWeight: "400",
              width: screenWidth > 1200 ? "50%" : "80%",
              marginTop: "10px",
              color: "white",
            }}
          >
            Here you will find answers to some of the most commonly asked
            questions about our work management platform, Premelo. If you have
            any additional questions that are not covered here, please do not
            hesitate to contact our support team for further assistance.
          </div>
        </div> */}
      </div>
      <div style={{ width: "80%", marginLeft: "10%", padding: "50px 0px" }}>
        <span style={{ fontWeight: 800 }}>Terms of Use</span>
        <br />
        <br />
        1.1 By accessing, browsing or using our platform, and any websites, any
        mobile application operated by us or linked to our platform, or any page
        thereof ("Platform"), through any direct or indirect means (individually
        or collectively), or by using or accessing the facilities or services
        (each a "Service", as the case may be) offered in or through the
        Platform or through alternative methods (including, for example,
        telephone, mail, email or facsimile). You accept and agree to be bound
        by these Terms of Use and any other document, terms or conditions that
        form part of the same, as may be amended, supplemented, modified or
        added from time to time (these "Terms of Use"). The Services will be
        provided in accordance with the relevant agreements or terms ("Terms of
        Service").
        <br />
        <br />
        1.2 If you do not agree to these Terms of Use, you are not authorised to
        access or use the Platform, and you are to cease accessing or otherwise
        using the Platform. The details, description, functions and process in
        respect of each Service will be set out on the Platform itself and may
        be revised, amended or supplemented from time to time. You agree that
        for your use of each Service, you will from time to time satisfy
        yourself by fully reading and understanding the details, description,
        functions, process and Terms of Service in respect of each Service,
        prior to using or purchasing any of the Services.
        <br />
        <br />
        1.3 SmartLend Financial Pte. Ltd. ("SmartLend") operates the Platform
        and shall have the right at any time to change or discontinue any aspect
        or feature of the Platform and the right to modify these Terms of Use,
        Terms of Service and/or any other terms and conditions applicable to
        users of the Platform, or any part thereof. Such changes, modification,
        additions or deletions shall be effective immediately upon posting on
        the Platform. Any continued use by you of the Platform or the use of the
        Services offered in or through the Platform shall be deemed to
        constitute your acceptance of such changes.
        <br />
        <br />
        1.4 In these Terms of Use, "we", "our" and "us" refers to SmartLend and
        "you" and "your" is defined to any person who accesses and uses the
        Platform.
        <br />
        <br />
        1.5 In the event of any express conflict between these Terms of Use and
        the Terms of Service for the use of any of our Services, or any other
        such terms and policies which may be promulgated from time to time, the
        terms in the Terms of Service shall take precedence.
        <br />
        <br />
        1.6 By using the Platform, you acknowledge that you have read,
        understood, and (i) agree to be bound by these Terms of Use; (ii) where
        you use our Service, agree to also be bound by the relevant Terms of
        Service; and (iii) you represent and warrant that you are at least 21
        years of age.
        <br />
        <br />
        <br />
        <span style={{ fontWeight: 800 }}>2. Accessing the Platform</span>
        <br />
        <br />
        2.1 We will use our best efforts to keep the Platform accessible at all
        times and while we will use our best efforts, we cannot guarantee that
        the Platform will be fully or partially operational at all times. You
        agree that we will not responsible for any losses that may arise from
        the inability to access to the Platform, from visiting the Platform
        and/or from the reliance on the information provided within the
        Platform.
        <br />
        <br />
        2.2 We reserve the right to withdraw or amend any Services that are
        provided on the Platform without any notice.
        <br />
        <br />
        <br />
        <span style={{ fontWeight: 800 }}>3. Acceptable Use</span>
        <br />
        <br />
        3.1 We intend for the Platform to be used for the Services only. The use
        of the Platform for any other purpose is strictly prohibited.
        <br />
        <br />
        3.2 You also agree:
        <br />
        <br />
        3.2.1 not to reproduce, duplicate, copy or re-sell any part of or
        information on the Platform in contravention of any applicable law and
        the provisions of these Terms of Use and Terms of Service; and
        <br />
        <br />
        3.2.2 not to access without authority, interfere with, damage or disrupt
        any part of the Platform or any software used in the provision of the
        Services on the Platform.
        <br />
        <br />
        3.3 You further agree that if you are allowed to publish, post,
        transmit, transfer, distribute, or upload any content, on or through the
        Platform, you will not, and will not permit any representative, nominee
        or agent of yours to, publish, post, transmit, transfer, distribute, or
        upload any content, on or through the Platform that:
        <br />
        <br />
        3.3.1 contains any material which is defamatory of any person;
        <br />
        <br />
        3.3.2 contains any material which is obscene, offensive, hateful or
        inflammatory;
        <br />
        <br />
        3.3.3 provides sexually explicit material;
        <br />
        <br />
        3.3.4 promotes violence;
        <br />
        <br />
        3.3.5 promotes discrimination based on race, sex, religion, nationality,
        disability, or sexual orientation;
        <br />
        <br />
        3.3.6 infringes any copyright, database right, or trademark of any other
        person or entity;
        <br />
        <br />
        3.3.7 contains any content that is not entirely your own or for which
        you do not have any full rights to use;
        <br />
        <br />
        3.3.8 is likely to deceive any person;
        <br />
        <br />
        3.3.9 is threatening, abusive, or invade another's privacy, or cause
        annoyance, inconvenience or needless anxiety;
        <br />
        <br />
        3.3.10 is likely to harass, upset, embarrass, alarm or annoy any other
        person;
        <br />
        <br />
        3.3.11 is used to impersonate any person, or to misrepresent your
        identity or affiliation with any person; or
        <br />
        <br />
        3.3.12 gives the impression that they emanate from us if it is not the
        case.
        <br />
        <br />
        3.4 We reserve the right, but not the obligation, to monitor any content
        you post on the Platform. We will have the right, but not the
        obligation, without your consent or any prior notice to you, to remove
        any content that in our sole opinion violates, or may violate any
        applicable law or these Terms of Use or upon the request of any third
        party.
        <br />
        <br />
        <br />
        <span style={{ fontWeight: 800 }}>
          4. SmartLend's employees, agents and officers
        </span>
        <br />
        <br />
        4.1 You will not harass, annoy, intimidate, or threaten any of our
        employee(s) or agent(s) engaged in providing any portion of the Services
        to you. If we feel that your behaviour towards any of our employees,
        agent or officer is at any time threatening or offensive, we reserve the
        right to deny you any further access to the Platform and Services
        provided, as well as to take all such steps as may be available at law
        against you.
        <br />
        <br />
        <br />
        <span style={{ fontWeight: 800 }}>5. Reliance on information</span>
        <br />
        <br />
        5.1 We may provide general information on the Platform and do not
        purport to be a financial, legal, tax or professional advisor. Nothing
        on the Platform shall be construed as financial, legal or any other
        professional advice.
        <br />
        <br />
        5.2 Any information provided by us is to be used at your own discretion
        and judgment. We strive to provide accurate information and unbiased
        opinions (if any) but we shall not be responsible in any way if any
        information is found to be inaccurate or contain any errors and/or
        omissions.
        <br />
        <br />
        <br />
        <span style={{ fontWeight: 800 }}>6. Changes to Content</span>
        <br />
        <br />
        6.1 We reserve the right to modify, add, delete or move any information,
        content, material, and data on the Platform at any time, without any
        prior notice to you.
        <br />
        <br />
        <br />
        <span style={{ fontWeight: 800 }}>7. Cookies and Your Information</span>
        <br />
        <br />
        7.1 We may use cookies and may also process information about you in
        accordance with our internal policy. By using the Platform, and
        accepting these Terms of Use, you consent to such processing and you
        warrant that all data provided by you is accurate.
        <br />
        <br />
        7.2 For further information in this aspect, please refer to our privacy
        policy at [https://www.smart-lend.com/privacy-policy] ("Privacy Policy")
        on how we collect, use and disclose information collected and received
        from you. By contracting with us under these Terms of Use, you also
        agree to be bound by our said Privacy Policy (as may be supplemented,
        amended or revised from time to time) or any part thereof.
        <br />
        <br />
        <br />
        <span style={{ fontWeight: 800 }}>8. Links on the Platform</span>
        <br />
        <br />
        8.1 We may provide links to third party websites as part of our service
        to you but it is not an endorsement of any of such third party websites.
        Third party websites are governed by their own terms of use and/or
        privacy policies and thus, we have no control over them. You may access
        these third party websites at your sole discretion and own risk. We
        shall not be liable for any loss you may incur, arising from your access
        to the third party websites. To the extent that any of these third
        parties may be carrying out any activities which are required to be
        regulated or approved by any government, regulator or agency under the
        laws of any jurisdiction, we do not represent that nor have the
        obligation to verify or ascertain that they are in fact so regulated or
        approved.
        <br />
        <br />
        <br />
        <span style={{ fontWeight: 800 }}>9. Intellectual Property</span>
        <br />
        <br />
        9.1 The content of the Platform including the text, graphics, and logo
        is our property and is protected by copyright and/or other proprietary
        rights. You may download, print, and store any copyright material for
        your personal use, but you shall not republish, distribute or
        commercially exploit the contents in any form without first obtaining
        our express written consent. You may not copy, reverse engineer,
        decompile, or create derivative works of the contents, or frame the
        Platform or any part of it. You may not modify or alter the contents in
        any way, or change or delete the copyright notice.
        <br />
        <br />
        <br />
        <span style={{ fontWeight: 800 }}>10. Indemnity</span>
        <br />
        <br />
        10.1 We shall not be liable for any loss that you may incur in any way
        that may arise from your access of the Platform and the transactions
        that you may end up conducting as a result of any Service(s) on the
        Platform. In this regard, you agree and acknowledge that you shall
        exercise due caution and judgment.
        <br />
        <br />
        10.2 You undertake fully and effectively to indemnify and keep
        indemnified at all times us and our officers, employees, agents or
        authorised representatives against all actions, proceedings, claims,
        costs, demands, liabilities and expenses whatsoever (including legal and
        other fees and disbursements) sustained, incurred or paid by us directly
        or indirectly in respect of:
        <br />
        <br />
        10.2.1 your access and/or use of the Service;
        <br />
        <br />
        10.2.2 any information data or material published or transmitted by you;
        and/or
        <br />
        <br />
        10.2.3 any breach by you of any of the provisions of these Terms of Use
        or of any code, law or regulation relating thereto.
        <br />
        <br />
        10.3 You, and your estate, in the case of your death, further agree that
        this indemnification provision covers all third party claims, actions or
        demands, including those filed by your spouse, partner, children, or any
        family member or relative. We reserve the right to assume the exclusive
        defence and control of any matter otherwise subject to indemnification
        by you, in which event you will fully cooperate with us in connection
        therewith.
        <br />
        <br />
        <br />
        <span style={{ fontWeight: 800 }}>11. Limitation of Liability</span>
        <br />
        <br />
        11.1 The content displayed on the Platform is provided without any
        guarantees, conditions or warranties as to its accuracy. To the fullest
        extent permitted by law, we hereby expressly exclude all conditions,
        warranties and other terms which might otherwise be implied by statute,
        common law or the law of equity; and any liability for any losses or
        damage incurred by any user in connection with the Services or access to
        the Platform and any materials posted on it.
        <br />
        <br />
        11.2 We expressly exclude liability for consequential loss, damage or
        corruption to other software or data or for loss of profit business
        revenue or goodwill incurred by any user.
        <br />
        <br />
        11.3 To the fullest extent permitted by law, we will in no event be
        liable for any damages whatsoever, whether direct, indirect, general,
        special, compensatory, consequential, and/or incidental, arising out of
        or relating to the conduct of you or anyone else in connection with the
        use of the Services, including without limitation, bodily injury,
        emotional distress, and/or other damages resulting from use of the
        Platform.
        <br />
        <br />
        11.4 Notwithstanding the generality of clause 11.3, to the fullest
        extent permissible under applicable laws, if we are for any reason held
        to be liable to you, howsoever and whatsoever the cause thereof, our
        liability will be limited to the amount actually received by us from
        you.
        <br />
        <br />
        <br />
        <span style={{ fontWeight: 800 }}>12. Disclaimers</span>
        <br />
        <br />
        12.1 We are not responsible for any incorrect or inaccurate content
        posted on the Platform or in connection with the Services, whether
        caused by users of the Platform, or by any of the equipment or
        programming associated with or utilised in the Services.
        <br />
        <br />
        12.2 We are not responsible for the conduct, whether online or offline,
        of any user of the Platform.
        <br />
        <br />
        12.3 We are not responsible for any error, omission, interruption,
        deletion, defect, delay in operation or transmission, communications
        line failure, theft or destruction or unauthorised access to, or
        alteration of, user or user communications.
        <br />
        <br />
        12.4 We do not guarantee that the Platform is or will be free of any
        viruses or anything that may be harmful technologically.
        <br />
        <br />
        12.5 We are not responsible for any problems or technical malfunction of
        any telephone network or lines, computer online systems, servers or
        providers, computer equipment, software, failure of email or players on
        account of technical problems or traffic congestion on the Internet or
        at any website or combination thereof, including injury or damage to
        users or to any other person's computer related to or resulting from
        participating or downloading materials in connection with the Platform
        and/or in connection with the Services.
        <br />
        <br />
        12.6 Under no circumstances will we be responsible for any loss or
        damage, resulting from anyone's use of the Platform or the Services, any
        content posted on the Platform or transmitted to any third party, or any
        interaction or contact between users of the Platform whether online or
        offline.
        <br />
        <br />
        12.7 This site is for informational purposes only. To the fullest extent
        allowed by law, we provide the Platform and Services on an "as is" and
        "as available" basis and grant no warranties of any kind, either
        express, implied, statutory or otherwise with respect to the Services or
        the Platform (including all content contained therein) including
        (without limitation) any implied warranties of satisfactory quality,
        merchantability, fitness for a particular purpose, expectations of
        privacy, or non-infringement. We do not warrant that the Platform or
        Services will be uninterrupted or error-free, secure, or that any
        defects or errors will be corrected. Any material downloaded or
        otherwise obtained through the use of the Services or Platform is
        accessed at your own discretion and risk, and you will be solely
        responsible and hereby waive any and all claims and causes of action
        with respect to any damage to your computer system, internet access,
        download or display device, or loss or corruption of data that results
        or may result from the download of any such material. If you do not
        accept this limitation of liability, you are not authorised to access,
        download or obtain any material through the Platform or use or access
        any Services.
        <br />
        <br />
        <br />
        <span style={{ fontWeight: 800 }}>
          13. Legal Jurisdiction and Dispute
        </span>
        <br />
        <br />
        13.1 Your use of the Platform and any dispute arising out of such use of
        the same, the relationship between you and us and these Terms of Use are
        subject to the laws of Singapore without reference to its conflict of
        laws principles and that the courts of Singapore shall have exclusive
        jurisdiction over any dispute arising out of or in connection with these
        Terms of Use. However, we retain the right to bring proceedings against
        you for breach of any of these Terms of Use in your country of residence
        or any other relevant country.
        <br />
        <br />
        13.2 If you access the Platform or use the Services from outside
        Singapore, to the maximum extent possible, you waive all rights under
        the laws and regulations of the territory from which you access or use
        the Platform or Services. Regardless of whether you access the Platform
        or use the Services from outside Singapore, all disputes shall be
        resolved in the courts of Singapore.
        <br />
        <br />
        <br />
        <span style={{ fontWeight: 800 }}>14. No Waiver</span>
        <br />
        <br />
        14.1 Any delay to exercise our rights under these Terms of Use does not
        constitute as a waiver of our rights. All of our rights are expressly
        reserved.
        <br />
        <br />
        <br />
        <span style={{ fontWeight: 800 }}>15. Ownership</span>
        <br />
        <br />
        15.1 https://www.smart-lend.com is fully owned and operated by SmartLend
        Financial Pte. Ltd. (UEN: 202327568G), a company incorporated in
        Singapore.
        <br />
        <br />
        <br />
        <span style={{ fontWeight: 800 }}>16. Rights of Third Parties</span>
        <br />
        <br />
        16.1 A person or entity who is not a party to this Terms of Use has no
        right under the Contracts (Rights of Third Parties) Act (Cap. 53B) or
        any similar legislation in any jurisdiction to enforce any term of the
        Terms of Use, regardless of whether such person or entity has been
        identified by name, as a member of a class, or as answering a particular
        description.
        <br />
        <br />
        <br />
        <span style={{ fontWeight: 800 }}>17. Severability</span>
        <br />
        <br />
        17.1 If any part of this Terms of Use are found to be illegal, void, or
        unenforceable (whether in part or in full), it will not be given any
        effect and will be deemed not to be part of the Terms of Use. However,
        such treatment of the relevant part of the Terms of Use does not
        invalidate any of the remaining parts of the Terms of Use.
      </div>

      {/* Footer section */}
      <div
        style={{
          padding: screenWidth > 1200 ? "40px 150px" : "40px 0px",
          display: "flex",
          justifyContent: "space-between",
          textAlign: screenWidth > 1200 ? "left" : "center",
          background: "rgba(0,0,0,0.1)",
          position: "relative",
          zIndex: 200,
        }}
      >
        <div style={{ width: screenWidth > 1200 ? "60%" : "100%" }}>
          <div
            style={{
              width: screenWidth > 1200 ? "40%" : "100%",
              fontWeight: "700",
              fontSize: "35px",
              color: "#256199",
            }}
          >
            SmartLend.
          </div>
          <div style={{ fontWeight: "600", fontSize: "18px" }}>
            Apply Once | Compare all
          </div>
          <div
            style={{
              fontWeight: "300",
              fontSize: "13px",
              width: screenWidth > 1200 ? "100%" : "80%",
              marginLeft: screenWidth > 1200 ? "0%" : "10%",
            }}
          >
            SmartLend Financial Pte. Ltd. Is part of Smart Towkay Brand
          </div>
          <div
            style={{ fontWeight: "600", fontSize: "18px", marginTop: "15px" }}
          >
            Singapore HQ
          </div>
          <div
            style={{
              fontWeight: "400",
              fontSize: "14px",
              marginTop: "3px",
              width: screenWidth > 1200 ? "100%" : "80%",
              marginLeft: screenWidth > 1200 ? "0%" : "10%",
            }}
          >
            114 Lavender St., #07-77 CT Hub 2, Singapore 338729
          </div>
          <div
            style={{ fontWeight: "400", fontSize: "14px", marginTop: "15px" }}
          >
            Folow us and Stay updated
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: screenWidth > 1200 ? "flex-start" : "center",
              marginTop: "15px",
              alignItems: "center",
            }}
          >
            <FacebookIcon
              onClick={() => {
                window.location.href =
                  "https://www.facebook.com/smarttowkaysg/";
              }}
              className="menu_button"
              style={{
                marginRight: "12px",
                color: "rgba(0,0,0,1)",
                cursor: "pointer",
              }}
            />
            <InstagramIcon
              onClick={() => {
                window.location.href =
                  "https://www.instagram.com/smart-towkay/";
              }}
              className="menu_button"
              style={{
                marginRight: "12px",
                color: "rgba(0,0,0,1)",
                cursor: "pointer",
              }}
            />
            {/* <TwitterIcon
              className="menu_button"
              style={{
                marginRight: "12px",
                color: "rgba(0,0,0,1)",
                cursor: "pointer",
              }}
            /> */}
            <img
              className="menu_button"
              src={tiktokIcon}
              onClick={() => {
                window.location.href = "https://www.tiktok.com/@towkaypeople";
              }}
              style={{
                width: 18,
                height: 18,
                objectFit: "cover",
                marginRight: "12px",
              }}
            />
            <img
              className="menu_button"
              src={telegramicon}
              onClick={() => {
                window.location.href = "https://t.me/smarttowkaysg";
              }}
              style={{
                width: 18,
                height: 18,
                objectFit: "cover",
                marginRight: "12px",
              }}
            />
            <img
              className="menu_button"
              src={linkedinicon}
              onClick={() => {
                window.location.href =
                  "https://www.linkedin.com/company/smart-towkay/?originalSubdomain=sg";
              }}
              style={{
                width: 18,
                height: 18,
                objectFit: "cover",
                marginRight: "12px",
              }}
            />
            <img
              className="menu_button"
              src={whatsappicon}
              onClick={() => {
                window.location.href = "https://wa.me/6587853373";
              }}
              style={{
                width: 18,
                height: 18,
                objectFit: "cover",
                marginRight: "12px",
              }}
            />
          </div>
        </div>
        {screenWidth > 1200 ? (
          <div style={{ width: "15%" }}>
            <div style={{ fontWeight: "600", fontSize: "20px" }}>Sitemap</div>
            <div
              style={{
                fontWeight: "300",
                fontSize: "14px",
                marginTop: "15px",
                cursor: "pointer",
              }}
              onClick={() => {
                history.push("/home");
                window.scrollTo(0, 0);
              }}
            >
              Home
            </div>
            <div
              style={{
                fontWeight: "300",
                fontSize: "14px",
                marginTop: "5px",
                cursor: "pointer",
              }}
              onClick={() => {
                history.push("/partner-with-us");
                window.scrollTo(0, 0);
              }}
            >
              Partner With Us
            </div>
            <div
              style={{
                fontWeight: "300",
                fontSize: "14px",
                marginTop: "5px",
                cursor: "pointer",
              }}
              onClick={() => {
                history.push("/frequentlyaskedquestions");
                window.scrollTo(0, 0);
              }}
            >
              Frequently Asked Questions
            </div>
            <div
              style={{
                fontWeight: "300",
                fontSize: "14px",
                marginTop: "5px",
                cursor: "pointer",
              }}
              onClick={() => {
                history.push("/news-events");
                window.scrollTo(0, 0);
              }}
            >
              News & Events
            </div>
            <div
              style={{
                fontWeight: "300",
                fontSize: "14px",
                marginTop: "5px",
                cursor: "pointer",
              }}
              onClick={() => {
                history.push("/contactus");
                window.scrollTo(0, 0);
              }}
            >
              Contact Us
            </div>
          </div>
        ) : null}
      </div>
      <div
        style={{
          background: "rgba(0,0,0,0.85)",
          justifyContent: "center",
          width: "100%",
          display: "flex",
          alignItems: "center",
          padding: "10px 0px",
          position: "relative",
          zIndex: 200,
        }}
      >
        <div
          style={{
            width: screenWidth > 1200 ? "60%" : "80%",
            color: "rgba(256,256,256,.9)",
            fontSize: screenWidth > 1200 ? "14px" : "10px",
            display: "flex",
            justifyContent: "center",
            gap: "10px",
            textAlign: "center",
          }}
        >
          <div
            className="hover_underline"
            style={{ cursor: "pointer" }}
            onClick={() => {
              history.push("/terms-and-conditions");
              window.scrollTo(0, 0);
            }}
          >
            Terms and Conditions
          </div>
          <div style={{ width: "10px" }}>•</div>
          <div>© SmartLend Financial Pte. Ltd.</div>
          <div style={{ width: "10px" }}>•</div>
          <div
            className="hover_underline"
            style={{ cursor: "pointer" }}
            onClick={() => {
              history.push("/privacy-policy");
              window.scrollTo(0, 0);
            }}
          >
            Privacy Policy
          </div>
        </div>
      </div>
    </div>
  );
};
export default TermCondition;
